import React from 'react';
import { useMediaQuery } from 'react-responsive';
import MarketingContent from './MarketingContent';

const Desktop = ({ children }) => {
  const isDesktop = useMediaQuery({ minWidth: 768 });
  return isDesktop ? children : null;
};

const DesktopResponsive = ({ history }) => (
  <Desktop>
    <MarketingContent history={history} />
  </Desktop>
);

export default DesktopResponsive;
